/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {CTCEntity} from '@ion/core/src/types/entities';

/**
 * Provides a utility hook for getting the delete operation results for any entity via
 * its respective reducer ...
 *
 * ```typescript
 *
 *   import {useDeleteResults} from '@ion/dls/src/hooks/';
 *   const deleteResult = useDeleteResults('reducer');
 *
 * ```
 */
export const useDeleteResults = (reducer: string): CTCEntity | CTCEntity[] => {
  return useSelector(({[reducer]: {destroy}}) => destroy?.result);
};

export default useDeleteResults;
